import React from "react";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { FormSectionProps } from "./types";

const AvailabilitySection: React.FC<FormSectionProps> = ({
  setValue,
  watchedFields,
  errors,
}) => {

  return (
    <div className="flex flex-col gap-2">
      <h3 className="text-lg">Availability</h3>
      <div className="space-y-6">
        <div className="space-y-2" data-question-field="readyToBegin">
          <Label>
            If we match you with a new role, how soon are you ready to begin?{" "}
            <span className="text-red-500">*</span>
          </Label>
          <RadioGroup
            value={watchedFields.readyToBegin}
            onValueChange={(value) =>
              setValue("readyToBegin", value as "immediately" | "7-days" | "14-days" | "30-days" | "other")
            }
            className="space-y-1 text-neutral-500"
          >
            <div className="flex items-center space-x-4">
              <RadioGroupItem value="immediately" id="begin-now" />
              <Label htmlFor="begin-now" className="font-normal cursor-pointer">
                Available immediately
              </Label>
            </div>
            <div className="flex items-center space-x-4">
              <RadioGroupItem value="7-days" id="begin-7" />
              <Label htmlFor="begin-7" className="font-normal cursor-pointer">
                7 days (one week)
              </Label>
            </div>
            <div className="flex items-center space-x-4">
              <RadioGroupItem value="14-days" id="begin-14" />
              <Label htmlFor="begin-14" className="font-normal cursor-pointer">
                14 days (two weeks)
              </Label>
            </div>
            <div className="flex items-center space-x-4">
              <RadioGroupItem value="30-days" id="begin-30" />
              <Label htmlFor="begin-30" className="font-normal cursor-pointer">
                30 days (one month)
              </Label>
            </div>
            <div className="flex items-center space-x-4">
              <RadioGroupItem value="other" id="begin-other" />
              <Label htmlFor="begin-other" className="font-normal cursor-pointer">
                Other
              </Label>
            </div>
          </RadioGroup>
          {errors.readyToBegin && (
            <p className="text-sm text-red-500">{errors.readyToBegin.message}</p>
          )}
        </div>

        <div className="space-y-2" data-question-field="openToFutureContact">
          <Label>
            Are you open to us contacting you about future opportunities that match your
            profile? <span className="text-red-500">*</span>
          </Label>
          <RadioGroup
            value={watchedFields.openToFutureContact}
            onValueChange={(value) => setValue("openToFutureContact", value as "yes" | "no")}
            className="space-y-1 text-neutral-500"
          >
            <div className="flex items-center space-x-4">
              <RadioGroupItem value="yes" id="future-yes" />
              <Label htmlFor="future-yes" className="font-normal cursor-pointer">
                Yes, you can contact me
              </Label>
            </div>
            <div className="flex items-center space-x-4">
              <RadioGroupItem value="no" id="future-no" />
              <Label htmlFor="future-no" className="font-normal cursor-pointer">
                No, I will pass
              </Label>
            </div>
          </RadioGroup>
          {errors.openToFutureContact && (
            <p className="text-sm text-red-500">{errors.openToFutureContact.message}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default AvailabilitySection;

